import Skeleton from 'react-loading-skeleton';
import React from 'react';

export const SavingsControllerLoader = () => (
  <div className='flex flex-col items-center gap-6 py-[10px]'>
    <Skeleton width='400px' height='20px' />
    <Skeleton width='400px' height='80px' />
  </div>
);
